var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { RequestConfiguration } from '../request-configuration/RequestConfiguration';
import { RequestRepresentation } from '../request-representation/RequestRepresentation';
import { ResponseView } from '../response-view/ResponseView';
import { EmptyView } from './EmptyView';
import { ErrorView } from './ErrorView';
import { ExecutingView } from './ExecutingView';
import { RequestDescriptorProvider, useRequest } from './useRequest';
export function useExecutions() {
    const [executions, setExecutions] = useState([]);
    const request = useRequest();
    const execute = () => __awaiter(this, void 0, void 0, function* () {
        const execution = { state: 'executing', request };
        setExecutions([...executions, execution]);
        try {
            const startTime = Date.now();
            const response = yield fetch(request);
            const endTime = Date.now();
            setExecutions([...executions.slice(0, -1), { state: 'executed', request, response, time: endTime - startTime }]);
        }
        catch (error) {
            setExecutions([...executions.slice(0, -1), { state: 'failed', request, error: error }]);
        }
    });
    const cancel = () => {
        setExecutions(executions.slice(0, -1));
    };
    return [executions, execute, cancel];
}
export function RequestViewContent() {
    const [executions, execute, cancel] = useExecutions();
    const currentExecution = executions.length > 0 ? executions[executions.length - 1] : null;
    const executing = (currentExecution === null || currentExecution === void 0 ? void 0 : currentExecution.state) === 'executing';
    const response = (currentExecution === null || currentExecution === void 0 ? void 0 : currentExecution.state) === 'executed' ? currentExecution.response : null;
    const time = (currentExecution === null || currentExecution === void 0 ? void 0 : currentExecution.state) === 'executed' ? currentExecution.time : null;
    const error = (currentExecution === null || currentExecution === void 0 ? void 0 : currentExecution.state) === 'failed' ? currentExecution.error : null;
    return (_jsxs("div", { className: "space-y-2 p-2", children: [_jsx(RequestConfiguration, {}), _jsx(RequestRepresentation, {}), !currentExecution && _jsx(EmptyView, {}), executing && _jsx(ExecutingView, {}), response && _jsx(ResponseView, { response: response, time: time !== null && time !== void 0 ? time : 0 }), error && _jsx(ErrorView, { error: error })] }));
}
export function RequestView() {
    return (_jsx(RequestDescriptorProvider, { children: _jsx(RequestViewContent, {}) }));
}
